import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosConfig";

export const notifySigners = createAsyncThunk(
  "documentList/notifySigners",
  async (data, { rejectWithValue, getState }) => {
    try {
      const {data} = await axiosInstance.post(`${api.baseURL}document/notify-signers`);
      return data
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
